"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsDateAfterToday = void 0;
const class_validator_1 = require("class-validator");
const IsDateAfterToday = (orEqualsTo, validationOptions) => (target, key) => {
    (0, class_validator_1.registerDecorator)({
        target: target.constructor,
        propertyName: key.toString(),
        name: 'isDateAfterToday',
        options: validationOptions,
        validator: {
            validate(value) {
                if (value === undefined)
                    return true;
                const localeNowString = new Date().toLocaleDateString('sv', {
                    timeZone: 'Europe/Amsterdam',
                });
                const today = new Date(localeNowString.split('T')[0]);
                if (orEqualsTo) {
                    today.setDate(today.getDate() - 1);
                }
                return typeof value === 'string' && new Date(value) > today;
            },
        },
    });
};
exports.IsDateAfterToday = IsDateAfterToday;
